// extracted by mini-css-extract-plugin
export default {"head":"topbar_head__IRrvv"};